// extracted by mini-css-extract-plugin
export default {"iconContainer":"icon_iconContainer__3Gr02"};